import React from 'react';
import axios from 'axios';
import { useState } from 'react';
import Cookies from 'js-cookie';
import './Join.css';

const url = process.env.REACT_APP_URL_LOCAL;

const Join = () => {
	const [email, setEmail] = useState('');
	const [content, setContent] = useState('');
	const [message, setMessage] = useState('');
	const handleSubmit = async (e) => {
		e.preventDefault();
		try {
			const body = {
				content,
				email,
			};
			const headers = {
				headers: {
					"authorization": `Bearer ${Cookies.get('mazeToken')}`,
				},
			};
			const response = await axios.post(`${url}/join-next-demos`, body, headers);
			if (response.data.message === 'OK') {
				setMessage('Merci!');
        setTimeout(() => {
          setMessage('')
        }, 3000);
			}
		} catch (error) {
			console.log(error);
		}
	};
	return (
		<>
			<section className="join-container">
				<h1>Tu veux faire partie du projet?</h1>
				<form className='join-container-form' onSubmit={handleSubmit}>
					<label htmlFor="text-content">Dis nous en quoi tu pourrais être utile</label>
					<textarea
						className='join-container-form-textarea'
						onChange={(e) => {
							setContent(e.target.value);
						}}
						id="text-content"
					></textarea>
					<label htmlFor="email">email</label>
					<input
						id='email'
						onChange={(e) => {
							setEmail(e.target.value);
						}}
						type="mail"
					/>
					<button>Envoyer</button>
				</form>
				{message && <p>{message}</p>}
			</section>
		</>
	);
};

export default Join;
